function themeToCssVars(theme) {
  const vars = [];

  function toKebabCase(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  }

  function flatten(obj, prefix = '') {
    for (const key in obj) {
      const value = obj[key];
      const kebabKey = toKebabCase(key);

      if (typeof value === 'object' && !Array.isArray(value)) {
        flatten(value, `${prefix}${kebabKey}-`);
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          vars.push(`--${prefix}${kebabKey}-${index}: ${item};`);
        });
      } else {
        vars.push(`--${prefix}${kebabKey}: ${value};`);
      }
    }
  }

  flatten(theme.palette.primary, 'primary-');
  flatten(theme.shape, 'shape-');
  flatten(theme.typography, 'typography-');

  return `:root {\n  ${vars.join('\n  ')}\n}`;
}

export default themeToCssVars;
